import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import httpService from "../../../../services/httpService";

const Filter = ({ onApply, onClear, initialFilters }) => {
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    httpService
      .get("/get-communication-roles")
      .then((res) => {
        const roles = res?.data || [];
        setRoleOptions(roles.map((r) => ({ label: r.title, value: r.id })));
      })
      .catch((err) => console.error("Error fetching roles: ", err));
  }, []);

  const initialValues = initialFilters || {
    date_range: {},
    role_id: "",
  };

  const formOptions = [
    {
      label: "Date Range",
      type: "date-range",
      name: "date_range",
      months: 1,
    },
    {
      label: "Role",
      type: "select",
      name: "role_id",
      placeholder: "Select Role",
      options: roleOptions
    },
  ];

  const handleSubmit = (values) => {
    const payload = { ...values };
    if (payload.date_range) {
      if (payload.date_range.from && payload.date_range.to) {
        payload.date_range_label = `${payload.date_range.from} - ${payload.date_range.to}`;
      } else {
        delete payload.date_range;
      }
    }
    
    if (payload.role_id) {
      const selectedRole = roleOptions.find(r => r.value === payload.role_id);
      if (selectedRole) {
        payload.role_id_label = selectedRole.label;
      }
    }

    onApply(payload);
  };

  const handleClear = () => {
    formik.resetForm();
    onClear({ date_range: null, role: "" });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>

        <Box sx={{ display: "flex", gap: 2, marginTop: "20px" }}>
          <LoadingButton fullWidth variant="outlined" onClick={handleClear}>
            Clear All
          </LoadingButton>
          <LoadingButton fullWidth type="submit" variant="contained">
            Apply Filter
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
};

export default Filter;
